import LawsuitTrackerLineChart from "./LawsuitTrackerLineChart";

export default LawsuitTrackerLineChart;
